//专注于客服使用的socket连接
import { wss } from "./utils";
import { netWorkPing } from "../api/system/sys_plateform";
import Cookies from "js-cookie";
import Vue from "vue";

const Setting = {
  wsSocketUrl: process.env.VUE_APP_WS_URL || "ws://kefu.weiquanai.com",
};

let reconneTimer = {};
let reconneCount = {};
let connectGuid = {};
let NetWork = null;

class wsSocket {
  constructor(opt) {
    this.vm = new Vue();
    this.ws = null;
    this.opt = opt || {};
    this.networkStatus = true;
    this.reconneMax = 100;
    this.connectLing = false;
    // 消息缓冲区：在 $on 注册监听器之前暂存服务器下发的消息，防止事件丢失
    this._messageBuffer = {};
    reconneTimer[this.opt.key] = null;
    reconneCount[this.opt.key] = 0;

    // 包装 $emit：当事件尚无监听器时，将数据暂存到缓冲区
    const origEmit = this.vm.$emit.bind(this.vm);
    const self = this;
    this.vm.$emit = function (event, ...args) {
      // 防御：服务器可能下发不带 type 字段的消息（如 ping 响应），
      // Vue 的 $emit 会对事件名做 toLowerCase()，传入 undefined 会抛异常
      if (!event) return;
      const hasListener =
        self.vm._events &&
        self.vm._events[event] &&
        self.vm._events[event].length > 0;
      if (!hasListener) {
        if (!self._messageBuffer[event]) {
          self._messageBuffer[event] = [];
        }
        self._messageBuffer[event].push(args);
      }
      return origEmit(event, ...args);
    };

    this.init(opt);
    this.networkWath();
    this.defaultEvenv();
  }

  defaultEvenv() {
    this.vm.$on("timeout", this.timeoutEvent.bind(this));
  }

  timeoutEvent() {
    //this.networkStatus = false;
    this.reconnect();
  }

  guid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  addHander(element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false);
    } else if (element.attachEvent) {
      element.attachEvent("on" + type, handler);
    } else {
      element["on" + type] = handler;
    }
  }

  networkStatusFn(onlineFn, offlineFn) {
    this.addHander(window, "online", onlineFn);
    this.addHander(window, "offline", offlineFn);
  }

  networkStatusFnv2(onlineFn, offlineFn) {
    if (NetWork) {
      clearInterval(NetWork);
      NetWork = null;
    }
    let online = null,
      offline = null;
    NetWork = setInterval(() => {
      netWorkPing()
        .then((res) => {
          if (online === null) {
            onlineFun();
            online = true;
          }
          offline = null;
        })
        .catch(() => {
          if (offline === null) {
            offlineFun();
            offline = true;
          }
          online = null;
        });
    }, 1000);
  }

  networkWath() {
    this.networkStatusFn(
      () => {
        this.networkStatus = true;
        console.log("联网了");
        this.vm.$on("timeout", this.timeoutEvent);
      },
      () => {
        this.networkStatus = false;
        this.socketStatus = false;
        this.timer && clearInterval(this.timer);
        this.timer = null;
        this.ws.close();
        console.log("断网了");
      }
    );
  }

  reconnect() {
    if (reconneCount[this.opt.key] > this.reconneMax) {
      //重连次数超过限制不再重连
      if (reconneTimer[this.opt.key]) {
        clearInterval(reconneTimer[this.opt.key]);
      }
      return;
    }
    if (reconneTimer[this.opt.key] || this.socketStatus) {
      return;
    }
    reconneTimer[this.opt.key] = setInterval(() => {
      //断线连接中发现状态为真就不用再连接
      if (this.socketStatus) {
        return;
      }
      //正在连接中也不需要在连接了
      if (!this.connectLing) {
        console.log("重新连接");
        this.init(this.opt);
        reconneCount[this.opt.key]++;
      }
    }, 2000);
  }

  onOpen() {
    //关闭断线重连定时器
    clearInterval(reconneTimer[this.opt.key]);
    reconneTimer[this.opt.key] = null;

    this.connectLing = false;
    this.opt.open && this.opt.open();
    reconneCount[this.opt.key] = 0;
    this.socketStatus = true;
    this.ping();
  }

  init(opt) {
    if (this.socketStatus) {
      return;
    }
    let wsUrl = "";
    let hostUrl = wss(Setting.wsSocketUrl);

    hostUrl = hostUrl + "/ws";

    if (opt.key == 1) {
      wsUrl = hostUrl + "?type=admin" + "&token=" + (Cookies.get("token") || "");
    }
    if (opt.key == 2) {
      wsUrl =
        hostUrl + `?type=kefu` + "&token=" + `${Cookies.get("kefu_token")}`;
    }
    if (opt.key == 3) {
      wsUrl = `${hostUrl}?type=user&form=${opt.form}&token=${opt.token}`;
    }
    if (opt.tourist_uid) {
      wsUrl += "&tourist_uid=" + opt.tourist_uid;
    }
    if (wsUrl) {
      this.connectLing = true;
      // connectGuid[opt.key] = this.guid();
      this.ws = new WebSocket(wsUrl);
      this.ws.onopen = this.onOpen.bind(this);
      this.ws.onerror = this.onError.bind(this);
      this.ws.onmessage = this.onMessage.bind(this);
      this.ws.onclose = this.onClose.bind(this);
    }
  }

  ping() {
    var that = this;
    this.timer = setInterval(() => {
      that.send({ type: "ping" });
    }, 10000);
  }

  send(data) {
    if (!this.socketStatus || this.ws.readyState === 0 || !this.networkStatus) {
      this.reconne();
    }
    return new Promise((resolve, reject) => {
      try {
        this.ws.send(JSON.stringify(data));
        resolve({ status: true });
      } catch (e) {
        console.log(e);
        reject({
          status: false,
          socketStatus: this.socketStatus,
          networkStatus: this.networkStatus,
        });
      }
    });
  }

  onMessage(res) {
    this.opt.message && this.opt.message(res);
  }

  onClose() {
    this.connectLing = false;
    this.timer && clearInterval(this.timer);
    this.timer = null;
    this.opt.close && this.opt.close();
    this.socketStatus = false;
    this.reconne();
  }

  onError(e) {
    this.connectLing = false;
    this.timer && clearInterval(this.timer);
    this.timer = null;
    this.opt.error && this.opt.error(e);
    this.socketStatus = false;
    this.reconne();
  }

  $on(...args) {
    const event = args[0];
    const handler = args[1];
    this.vm.$on(...args);
    // 回放缓冲区中暂存的消息，确保注册前到达的事件不丢失
    const events = Array.isArray(event) ? event : [event];
    const self = this;
    events.forEach((evt) => {
      if (self._messageBuffer[evt] && self._messageBuffer[evt].length > 0) {
        self._messageBuffer[evt].forEach((bufferedArgs) => {
          handler(...bufferedArgs);
        });
        delete self._messageBuffer[evt];
      }
    });
  }

  $off(...args) {
    this.vm.$off(...args);
  }
}


let promises = {};

function createSocket(key, flag, token, tourist_uid, type, form) {
    if (flag) promises[key] = null;
    if (!promises[key]) {
        promises[key] = new Promise((resolve, reject) => {
            const ws = new wsSocket({
                key,
                token,
                tourist_uid,
                type,
                form,
                open() {
                    resolve(ws);
                },
                error(e) {
                    reject(e)
                },
                message(res) {
                    const {type, data = {}} = JSON.parse(res.data);
                    ws.vm.$emit(type, data);
                },
                close(e) {
                    ws.vm.$emit('close', e);
                }
            })
        });
    }

    return promises[key];
}


export const adminSocket = (flag, token) => createSocket(1, flag, token);
export const Socket = (flag, token, tourist_uid, type) => createSocket(2, flag, token, tourist_uid, type);
export const mobileSocket = (flag, token, form, tourist_uid, type,) => createSocket(3, flag, token, tourist_uid, type, form);